import React from 'react'

export function MobileFloatingButtons() {
  const handleNavigation = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault()
    window.history.pushState({}, '', href)
    window.dispatchEvent(new Event('popstate'))
    window.scrollTo(0, 0)
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 flex md:hidden bg-white shadow-[0_-4px_10px_rgba(0,0,0,0.1)]">
      <a
        href="tel:4032865400"
        className="flex-1 flex flex-col items-center justify-center py-3 border-r border-gray-200 text-gray-900 active:bg-gray-100 transition-colors"
        onClick={() => {
          (window as any).dataLayer = (window as any).dataLayer || [];
          (window as any).dataLayer.push({ event: 'phone_click' });
        }}
      >
        <i className="fas fa-phone-alt text-beaver-green text-xl mb-1"></i>
        <span className="text-[11px] font-bold font-accent uppercase tracking-wider">
          Call Now
        </span>
      </a>
      
      <a
        href="/appointment"
        onClick={(e) => handleNavigation(e, '/appointment')}
        className="flex-1 flex flex-col items-center justify-center py-3 bg-beaver-green text-black active:brightness-90 transition-colors"
      >
        <i className="fas fa-calendar-check text-xl mb-1"></i>
        <span className="text-[11px] font-bold font-accent uppercase tracking-wider">
          Free Estimate
        </span>
      </a>
    </div>
  )
}